// extracted by mini-css-extract-plugin
export default {"ButtonCounter":"ButtonCounter_ButtonCounter__k74NM","buttonInc":"ButtonCounter_buttonInc__VVlLd","buttonReset":"ButtonCounter_buttonReset__i9P22"};